import { render, staticRenderFns } from "./ArtistNickname.vue?vue&type=template&id=8973d33c&scoped=true"
import script from "./ArtistNickname.vue?vue&type=script&lang=js"
export * from "./ArtistNickname.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8973d33c",
  null
  
)

export default component.exports